export const rolesArray = ['スタッフ', 'リーダー', '役員', '管理', 'VBPO']

export const teamsArray = ['経理', '給与', 'サポート']

export const workTypesArray = ['一般', '時給', 'アルバイト']
export const userStatusHash = {
    creating: "作成中",
    enable: "有効",
    disable: "無効",
    failed: "失敗"
};
export const userStatusOptions =[
    {text:"有効", value: "enable"},
    {text:"無効", value: "disable"},

]